import { render, staticRenderFns } from "./UpdateBox.vue?vue&type=template&id=6518d370&scoped=true"
import script from "./UpdateBox.vue?vue&type=script&lang=js"
export * from "./UpdateBox.vue?vue&type=script&lang=js"
import style0 from "./UpdateBox.vue?vue&type=style&index=0&id=6518d370&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6518d370",
  null
  
)

export default component.exports